import React, { FunctionComponent, useCallback } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { Participant } from './Participant';
import { IParticipantListProps } from './types';

export const ParticipantList: FunctionComponent<IParticipantListProps> = ({
  userIds,
  meetingId,
  reorder,
  handleUserIds,
}) => {
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);

  const handleDrop = useCallback(
    (result: DropResult) => {
      if (result.destination) {
        const userId = result.draggableId;
        const sourceIndex = result.source.index;
        const destinationIndex =
          result.destination.index > userIds.length ? result.destination.index - 1 : result.destination.index;
        if (meeting) {
          if (sourceIndex !== destinationIndex) {
            if (destinationIndex > sourceIndex) {
              userIds.splice(sourceIndex, 1);
              const newUserIds = [
                ...userIds.slice(0, destinationIndex - 1),
                userId,
                ...userIds.slice(destinationIndex - 1),
              ];
              handleUserIds(newUserIds);
            } else {
              userIds.splice(sourceIndex, 1);
              const newUserIds = [...userIds.slice(0, destinationIndex), userId, ...userIds.slice(destinationIndex)];
              handleUserIds(newUserIds);
            }
          }
        }
      }
    },
    [handleUserIds, meeting, userIds],
  );

  return (
    <DragDropContext onDragEnd={handleDrop}>
      <div className="members_list flex aic jcl px-2 flex-wrap">
        {userIds.map(
          (userId, index) =>
            userId && (
              <Droppable droppableId={userId} key={index} direction="horizontal" type="column">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    <Draggable
                      key={`draggable-row-${userId}`}
                      draggableId={userId}
                      index={index}
                      isDragDisabled={!reorder}
                    >
                      {(provided) => <Participant key={userId} userId={userId} provided={provided} />}
                    </Draggable>
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            ),
        )}
      </div>
    </DragDropContext>
  );
};
